import { environment } from '../src/environments/environment';
import UIConstants from './ui-constants';
export default {
  Act_Viewer_Service: {
    BASE_URL: `${environment.api_base_url}/logdata/${UIConstants.General.SYSTEM_NAME}`,
    DELETE_LOGS: `${environment.api_base_url}/purgelogdata/${UIConstants.General.SYSTEM_NAME}`,
  },

  Auth_Service: {
    BASE_URL: `${environment.api_base_url}/auth/login/${UIConstants.General.SYSTEM_NAME}`,
  },
  Config_Service: {
    BASE_URL: `${environment.api_base_url}/configdata/${UIConstants.General.SYSTEM_NAME}`,
    UPDATE_PRODUCT_TYPES: `${environment.api_base_url}/configdata/${UIConstants.General.SYSTEM_NAME}/InjectorTypes`,
  },

  Country_List_Service: {
    BASE_URL: `${environment.api_base_url}/CountryList/${UIConstants.General.SYSTEM_NAME}`,
  },

  User_Service: {
    BASE_URL: `${environment.api_base_url}/userProfile/${UIConstants.General.SYSTEM_NAME}`,
    BULK_URL: `${environment.api_base_url}/bulkUserProfile/${UIConstants.General.SYSTEM_NAME}`,
  },
};
